import { SVGProps, Ref, forwardRef } from 'react';

export const RadiusFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M16.818 1.793C15.476 1.286 13.881 1 12 1 3.75 1 1 6.5 1 12s2.75 11 11 11 11-5.5 11-11c0-1.649-.247-3.297-.815-4.798-.622.402-1.371.598-2.185.598-.745 0-1.437-.165-2.026-.501l-2.486 2.486c.36.66.512 1.438.512 2.215 0 2-1 4-4 4s-4-2-4-4 1-4 4-4c.919 0 1.65.188 2.222.505l2.483-2.483C16.32 5.345 16.2 4.612 16.2 4c0-.667.143-1.48.618-2.207"
                fill="currentColor"
            />
            <path
                d="M21.388 5.554C21.074 5.827 20.623 6 20 6q-.141 0-.27-.011C18.44 5.875 18 4.938 18 4q0-.048.002-.096c.015-.481.15-.954.461-1.309C18.777 2.237 19.27 2 20 2c1.5 0 2 1 2 2 0 .585-.17 1.17-.612 1.554"
                fill="currentColor"
            />
            <path
                d="M10.258 10.402c-.271.326-.458.865-.458 1.598s.187 1.272.458 1.598c.223.267.675.602 1.742.602s1.52-.335 1.742-.602c.271-.326.458-.865.458-1.598s-.187-1.272-.458-1.598C13.52 10.135 13.067 9.8 12 9.8s-1.52.335-1.742.602"
                fill="currentColor"
            />
        </g>
    </svg>
));
RadiusFilledSize24Glyph.displayName = 'RadiusFilledSize24Glyph';
